export const SET_CONTENT_SUBMISSION_MODAL_OPEN = 'SET_CONTENT_SUBMISSION_MODAL_OPEN';
